import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  details: null,
  account: null,
  authToken: null,
  deviceToken: null,
  notifications:[]
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUser: (state, action) => {
      console.log("updating user");
      state.details = action.payload.details ? action.payload.details : state.details;
      state.account = action.payload.account ? action.payload.account : state.account;
      state.authToken = action.payload.authToken ? action.payload.authToken : state.authToken;
      state.deviceToken = action.payload.deviceToken ? action.payload.deviceToken : state.deviceToken;
      state.notifications = action.payload.notifications ? action.payload.notifications : state.notifications;
      console.log('user', state.details)
    },
    updateUserDetails: (state, action) => {
      console.log("updating user details in redux", action.payload);
      state.details = action.payload;
    },
    updateUserAccount: (state, action) => {
      console.log("updating user account in redux", action.payload);
      state.account = action.payload;
    },
    updateUserAuthToken: (state, action) => {
      console.log("updating token", action.payload);
      state.authToken = action.payload;
    },
    updateUserDeviceToken: (state, action) => {
      console.log("updating device token", action.payload);
      state.deviceToken = action.payload;
    },
    updateNotifications: (state, action) => {
      console.log("updating notifications", action.payload);
      state.notifications = action.payload;
    },
    clearUser: (state) => {
      state.details = null;
      state.authToken = null;
      state.deviceToken = null;
      state.account = null;
      console.log("cleared user state");
    }
  },
});

export const {
  updateUser,
  updateUserAccount,
  updateAuthToken,
  updateDeviceToken,
  updateNotifications,
  updateUserDetails,
  clearUser
} = userSlice.actions;

export default userSlice.reducer;
